export default __webpack_public_path__ + "static/media/mofflive.8a5e3683.png";